import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { PATHS } from './config/consts';
import Home from './pages/Home';

const App = () => {
    const { i18n } = useTranslation();
    document.body.dir = i18n.dir();

    return (
        <BrowserRouter>
            <Routes>
                <Route path={PATHS.HOME} exact element={<Home />}></Route>
            </Routes>
        </BrowserRouter>
    );
};

export default App;
